import { NotificationConfiguration } from '../notification.templates';

export const GUEST_PUBLISH_AGENDA_TEMPLATE: NotificationConfiguration = {
  inapp: `You are invited to a new meeting for the agenda item <b>{title}</b>.`,
  email: {
    ctaKey: 'go_to_agenda_item',
  },
};
